import type { NDateLocale } from './enUS'
import { eu } from 'date-fns/locale'

const dateEuES: NDateLocale = {
  name: 'eu-ES',
  locale: eu
}

export default dateEuES
